import React from 'react';
import { type FieldValues, type Path, type PathValue } from 'react-hook-form';

import { useFormElement } from '../useFormElement';

import { BaseQuantityInput, type BaseQuantityInputProps } from './BaseQuantityInput';

export type QuantityInputProps<T extends FieldValues, FP extends Path<T>> = Omit<
	BaseQuantityInputProps,
	'hasError' | 'name' | 'onChange' | 'ref' | 'value'
> & {
	defaultValue?: PathValue<T, FP>;
	name: FP;
};

/**
 *
 * @param {QuantityInputProps} props - The component's props
 * @param {string} label - label to display
 * @param {string} children - use this in case label is not enough
 * @param {string} defaultChecked - initial checked state
 * @param {string} disabled - is the checkbox disabled
 * @param {boolean} isOnError - can be used to activate the on-error style
 * @param {function} onChange - on box click change callback
 */
export function QuantityInput<T extends FieldValues, FP extends Path<T> = Path<T>>({
	defaultValue,
	name,
	...props
}: QuantityInputProps<T, FP>) {
	const {
		field,
		fieldState: { error }
	} = useFormElement<T, FP>({
		defaultValue,
		name
	});

	return <BaseQuantityInput {...field} error={error} {...props} />;
}
